import { $DKD, $GCD, $CD } from '@/conf/common.const.js';
import commonApi from "@/api/common.api.js";

export default  {
    state: {
        bureauList: [],
        cooperationDataMap: {},
        promiseCategoryList: [],
        promiseBusinessDataMap: {},
        governanceCategoryList: [],
        governanceDataMap: {}
    },
    getters: {
        getBureauList(state) {
            return state.bureauList;
        },
        getCooperationDataMap(state) {
            return state.cooperationDataMap;
        },
        getPromiseCategoryList(state) {
            return state.promiseCategoryList;
        },
        getPromiseBusinessDataMap(state) {
            return state.promiseBusinessDataMap;
        },
        getGovernanceCategoryList(state) {
            return state.governanceCategoryList;
        },
        getGovernanceDataMap(state) {
            return state.governanceDataMap;
        }
    },
    mutations: {
        SET_BUREAU_LIST(state, bureauList) {
            state.bureauList = bureauList;
        },
        SET_COOPERATION_DATA_MAP(state, cooperationDataMap) {
            state.cooperationDataMap = cooperationDataMap;
        },
        SET_PROMISE_CATEGORY_LIST(state, promiseCategoryList) {
            state.promiseCategoryList = promiseCategoryList;
        },
        SET_PROMISE_BUSINESS_DATA_MAP(state, promiseBusinessDataMap) {
            state.promiseBusinessDataMap = promiseBusinessDataMap;
        },
        SET_GOVERNANCE_CATEGORY_LIST(state, governanceCategoryList) {
            state.governanceCategoryList = governanceCategoryList;
        },
        SET_GOVERNANCE_DATA_MAP(state, governanceDataMap) {
            state.governanceDataMap = governanceDataMap;
        }
    },
    actions : {
        FETCH_BUREAU_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($GCD.BUREAU)
                .then((res) => {
                    // 감사담당관, 의회사무국, 홍보담당관, 협치담당관 제외
                    let bureauList = res.data.data.filter(bureau => {
                        return $CD.BUREAU_GAMSA != bureau.commonCode &&
                           $CD.BUREAU_HYUBCHI != bureau.commonCode &&
                           $CD.BUREAU_HONGBO != bureau.commonCode &&
                           $CD.BUREAU_UIHOE != bureau.commonCode;
                    });

                    commit('SET_BUREAU_LIST', bureauList);
                })
        },
        FETCH_COOPERATION_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.COOPERATION)
                .then((res) => {
                    let cooperationList = res.data.data;
                    let cooperationDataMap = {};

                    // 사업번호 오름차순 정렬
                    cooperationList.sort((pre, cur) => {
                        return parseInt(pre.val1) > parseInt(cur.val1) ? 1 : parseInt(pre.val1) < parseInt(cur.val1) ? -1: 0;
                    });

                    cooperationList.forEach(cooperation => {
                        if(typeof cooperationDataMap[cooperation.val9] === 'undefined') {
                            cooperationDataMap[cooperation.val9] = [];
                        }
                        cooperationDataMap[cooperation.val9].push(cooperation);
                    });

                    commit('SET_COOPERATION_DATA_MAP', cooperationDataMap);
                })
        },
        FETCH_PROMISE_CATEGORY_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($GCD.PROMISE_CAT)
                .then((res) => {
                    commit('SET_PROMISE_CATEGORY_LIST', res.data.data);
                })
        },
        FETCH_PROMISE_BUSINESS_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.PROMISE, '', true)
                .then((res) => {
                    let promiseBusinessList = res.data.data;
                    let promiseBusinessDataMap = {};
                    let sortArr = [];
                    let splitArr = [];

                    promiseBusinessList.forEach(promiseBusiness => {
                        sortArr.push(promiseBusiness.val1);
                    });

                    // 사업번호 오름차순 정렬
                    promiseBusinessList.sort((pre, cur) => {
                        for(let i = 0; i < sortArr.length; i++) {
                            splitArr[i] = sortArr[i].split("-");
                            for(let j = 0; j < splitArr[i].length; j++) {
                                if(splitArr[i][j].length == 1) {
                                    splitArr[i][j] = "0" + splitArr[i][j];
                                } else {
                                    splitArr[i][j];
                                }
                                sortArr[i] = splitArr[i].join("");
                            }
                        }
                        return pre.val1 > cur.val1 ? 1 : pre.val1 < cur.val1 ? -1: 0;
                    });

                    promiseBusinessList.forEach(promiseBusiness => {
                        if(typeof promiseBusinessDataMap[promiseBusiness.val9] === 'undefined') {
                            promiseBusinessDataMap[promiseBusiness.val9] = [];
                        }
                        promiseBusinessDataMap[promiseBusiness.val9].push(promiseBusiness);
                    });

                    commit('SET_PROMISE_BUSINESS_DATA_MAP', promiseBusinessDataMap);
                })
        },
        FETCH_GOVERNANCE_CATEGORY_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($GCD.GOVERNANCE_CAT)
                .then((res) => {
                    res.data.data.sort((pre, cur) => {
                        return pre.commonCodeEngNm > cur.commonCodeEngNm ? -1 : pre.commonCodeEngNm < cur.commonCodeEngNm ? 1: 0;
                    });
                    commit('SET_GOVERNANCE_CATEGORY_LIST', res.data.data);
                })
        },
        FETCH_GOVERNANCE_DATA_LIST({commit}) {
            let governanceDataMap = {};

            return commonApi.fetchRepoDataList($DKD.GOVERNANCE_FOUND)
                .then((res) => {
                    let sortArr = [];
                    let splitArr = [];

                    res.data.data.forEach(govFound => {
                        sortArr.push(govFound.val1);
                    });

                 // 사업번호 오름차순 정렬
                    res.data.data.sort((pre, cur) => {
                        for(let i = 0; i < sortArr.length; i++) {
                            splitArr[i] = sortArr[i].split("-");
                            for(let j = 0; j < splitArr[i].length; j++) {
                                if(splitArr[i][j].length == 1) {
                                    splitArr[i][j] = "0" + splitArr[i][j];
                                } else {
                                    splitArr[i][j];
                                }
                                sortArr[i] = splitArr[i].join("");
                            }
                        }
                        return pre.val1 > cur.val1 ? 1 : pre.val1 < cur.val1 ? -1: 0;
                    });

                    governanceDataMap[$CD.GOVERNANCE_FOUND] = res.data.data;
                    return commonApi.fetchRepoDataList($DKD.GOVERNANCE_INNO);
                })
                .then((res) => {
                    governanceDataMap[$CD.GOVERNANCE_INNO] = res.data.data;

                    res.data.data.sort((pre, cur) => {
                        return parseInt(pre.val1) > parseInt(cur.val1) ? 1 : parseInt(pre.val1) < parseInt(cur.val1) ? -1: 0;
                    });

                    commit('SET_GOVERNANCE_DATA_MAP', governanceDataMap);
                })
        }
    }
};
